import { TextField, TextFieldProps } from '@mui/material';
import ErrorIcon from '@mui/icons-material/Error';
import React from 'react';
import { Container } from './styles';

type CurrencyInputProps = {
  value: number;
  onChange: (value: number) => void;
  errorMessage?: string;
} & Omit<TextFieldProps, 'onChange' | 'value'>;

const CurrencyInput: React.FC<CurrencyInputProps> = ({
  value,
  onChange,
  errorMessage,
  ...props
}) => {
  return (
    <Container>
      <TextField
        {...props}
        error={!!errorMessage}
        style={{ borderColor: errorMessage ? 'red' : undefined }}
        value={
          value?.toLocaleString('pt-BR', {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
          }) ?? ''
        }
        onChange={(e) => {
          let v = e.target.value.replace(/\D/g, '');
          v = `${(Number(v) / 100).toFixed(2)}`;
          v = v.replace('.', ',');
          v = v.replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1.');

          const newLimit = parseFloat(v.replace(/[^0-9,]+/g, '').replace(',', '.'));

          onChange(newLimit);
        }}
      />
      {errorMessage && (
        <span className="fieldError">
          <ErrorIcon fontSize="inherit" /> {errorMessage}
        </span>
      )}
    </Container>
  );
};
export default CurrencyInput;
